import { XhrFactory } from '@angular/common';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BaseSite, OCC_BASE_URL_META_TAG_NAME, OCC_BASE_URL_META_TAG_PLACEHOLDER } from '@spartacus/core';
import { SlbOccEndpoints } from '../config/slb-occ.endpoints';
import { INITIAL_CONFIG } from 'app/utils/consts';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SlbConfigService {
  private currentConfig: { code: string, value: string }[] = []

  constructor(private meta: Meta, private xhrFactory: XhrFactory) { }


  getSlbConfig(): { code: string, value: string }[] {
    if (this.currentConfig.length) return this.currentConfig;
    try {
      let occBaseUrl = this.getOccBaseUrl();
      let request = this.xhrFactory.build();
      request.open('GET', occBaseUrl + `/${environment.appConfig.occ.prefix}/${SlbOccEndpoints.basesites}`, false);
      request.send();

      if (request.status == 200) {
        let { baseSites } = JSON.parse(request.responseText);
        let slbBaseSite = baseSites.find((baseSite: BaseSite) => baseSite.uid === INITIAL_CONFIG.SPA_BASE_SITE);
        this.currentConfig = [...slbBaseSite?.configurations, {code: 'SPA_BASE_URL', value: occBaseUrl }];
        return this.currentConfig;
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  }

  private getOccBaseUrl() {
    let occBaseUrl = this.meta.getTag("name='" + OCC_BASE_URL_META_TAG_NAME + "'")?.getAttribute("content");

    if (occBaseUrl !== undefined && occBaseUrl != OCC_BASE_URL_META_TAG_PLACEHOLDER) {
      return occBaseUrl;
    } else {
      return environment.appConfig.occ.baseUrl;
    }
  }

}
